<template>
    <div class="home">
        <template v-if="isShowPage && langloadingDone">
            <!-- 卡片列表 -->
            <v-panel-content :data-salce="triggerSideNavShow">
                <TagList />
            </v-panel-content>
        </template>
        <template v-else>
            <div class="loading-wrap" ref="loadingWrap">
                <v-spinner />
            </div>
        </template>
        <transition name="slide-left">
            <favorites-enter-card v-if="favariteEnterCardShow" />
        </transition>
    </div>
</template>

<script>
import { mapState } from "vuex";
import TagList from "@/components/tag-list/index";
import favoritesEnterCard from "@/components/favorites-enter-card/index";

export default {
    name: "home",
    data() {
        return {
            menuDataLoad: false,
            show: false
        };
    },
    computed: {
        ...mapState("global", ["langloadingDone"]),
        ...mapState("mixins", ["isShowPage", "triggerSideNavShow"]),
        ...mapState("favorites", ["favariteEnterCardShow"])
    },
    components: {
        TagList,
        favoritesEnterCard
    },
    created() {},
    mounted() {},
    beforeDestroy() {},
    methods: {}
};
</script>

<style lang="scss">
.home {
}
</style>
